"use strict";

import Alert from "../../../librairies/Alert";

export default class UsersPermissionsList {
  constructor($usersPermissionsList) {
    this.$usersPermissionsList = $usersPermissionsList;
    this.$permissionManagementTableBody = this.$usersPermissionsList.querySelector("#permission-management table tbody");
    this.$userSelect = this.$usersPermissionsList.querySelector("#user-select");
    this.$permissionCheckboxes = this.$usersPermissionsList.querySelectorAll(".permission-management--checkbox");
    this.$buttonSave = this.$usersPermissionsList.querySelector("#permission-management--footer button");

    this.selectedUserID = this.$userSelect.value;

    this.permissionLabels = {
      "C": "create",
      "R": "read",
      "U": "update",
      "D": "delete"
    };

    this.permissionIndicators = {
      "C": document.querySelector('html').getAttribute('lang').toLowerCase() === 'fr' ? "Créer" : "Create",
      "R": document.querySelector('html').getAttribute('lang').toLowerCase() === 'fr' ? "Lire" : "Read",
      "U": document.querySelector('html').getAttribute('lang').toLowerCase() === 'fr' ? "Éditer" : "Update",
      "D": document.querySelector('html').getAttribute('lang').toLowerCase() === 'fr' ? "Supprimer" : "Delete"
    };

    this.bindEvents();
  }

  bindEvents() {
    this.listenPermissionCheckboxes();

    this.$userSelect.addEventListener("change", (event) => {
      this.selectedUserID = event.target.value;
      this.$buttonSave.disabled = true;
      this.refreshTable();
    });

    this.$buttonSave.addEventListener("click", () => {
      this.savePermissions();
    });
  }

  listenPermissionCheckboxes() {
    this.$permissionCheckboxes.forEach($checkbox => {
      $checkbox.addEventListener("change", () => {
        if (this.$buttonSave.disabled) {
          this.$buttonSave.disabled = false;
        }
      });
    });
  };

  refreshTable() {
    fetch(window.location.origin + '/api/users/permissions/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        for: this.selectedUserID,
        by: 'module'
      })
    })
    .then(response => response.json())
    .then(permissionsByModule => {
      this.constructTable(permissionsByModule);
    })
    .then(() => {
      this.$permissionManagementTableBody = this.$usersPermissionsList.querySelector("#permission-management table tbody");
      this.$permissionCheckboxes = this.$usersPermissionsList.querySelectorAll(".permission-management--checkbox");
    })
    .then(() => {
      this.listenPermissionCheckboxes();
    })
    .catch(error => {
      if (localStorage.getItem('isDevMode') === '1') {
        console.error('Error:', error);
      }
    });
  }

  constructTable(permissionsByModule) {
    this.$permissionManagementTableBody.innerHTML = "";

    for (const moduleID in permissionsByModule) {
      const moduleName = permissionsByModule[moduleID].name;
      const permissions = permissionsByModule[moduleID].permissions;

      const $row = document.createElement("tr");

      const $moduleName = document.createElement("td");
      $moduleName.textContent = moduleName;
      $moduleName.id = `module-${moduleID}`;
      $row.appendChild($moduleName);

      const $permissionsContainer = document.createElement("td");

      const $permissions = document.createElement("section");
      $permissions.classList.add("permission-management--cell");

      for (const shortLabel of Object.keys(this.permissionLabels)) {
        const $permissionUnit = document.createElement("div");
        $permissionUnit.classList.add("permission-management--unit");

        const $permissionLabel = document.createElement("label");
        $permissionLabel.setAttribute("for", `${this.permissionLabels[shortLabel]}-module-${moduleID}`);
        $permissionLabel.textContent = this.permissionIndicators[shortLabel];

        const $permissionInput = document.createElement("input");
        $permissionInput.setAttribute("type", "checkbox");
        $permissionInput.setAttribute("name", `module-${moduleID}-permissions-${this.permissionLabels[shortLabel]}`);
        $permissionInput.setAttribute("id", `${this.permissionLabels[shortLabel]}-module-${moduleID}`);
        $permissionInput.classList.add("permission-management--checkbox");
        $permissionInput.checked = permissions.includes(shortLabel);

        $permissionUnit.appendChild($permissionLabel);
        $permissionUnit.appendChild($permissionInput);
        $permissions.appendChild($permissionUnit);
      }

      $permissionsContainer.appendChild($permissions);

      $row.appendChild($permissionsContainer);
      this.$permissionManagementTableBody.appendChild($row);
    }
  }

  getPermissionsObject() {
    const permissions = new Object();
    this.$permissionManagementTableBody.querySelectorAll("tr").forEach($row => {
      let moduleID;
      $row.querySelectorAll("td").forEach(($cell, index) => {
        if (index === 0) {
          moduleID = $cell.id.split("-")[1];
          permissions[moduleID] = new Object();
        } else if (index === 1) {
          permissions[moduleID].permissions = new Object();
          $cell.querySelectorAll(".permission-management--unit").forEach($unit => {
            const permissionLabel = $unit.querySelector("input[type=checkbox]").id.split("-")[0];
            const isChecked = $unit.querySelector("input[type=checkbox]").checked;
            const shortLabel = Object.keys(this.permissionLabels).find(key => this.permissionLabels[key] === permissionLabel);
            permissions[moduleID].permissions[shortLabel] = isChecked;
          });
        }
      })
    });

    return permissions;
  }

  savePermissions() {
    fetch(window.location.origin + '/api/users/permissions/save/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        for: this.selectedUserID,
        permissions: this.getPermissionsObject()
      })
    })
    .then(response => response.json())
    .then(response => {
      this.$buttonSave.disabled = true;
      if (document.querySelector('html').getAttribute('lang').toLowerCase() === 'fr') {
        Alert.success("Les permissions ont été mises à jour avec succès.");
      } else {
        Alert.success("The permissions have been successfully updated.");
      }
    })
    .catch(error => {
      if (localStorage.getItem('isDevMode') === '1') {
        console.error('Error:', error);
      }
    });
  }
}
